module.exports = __webpack_public_path__ + "static/img/6.c0e2071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/6.jpg
// module id = 9wto
// module chunks = 0